export default __webpack_public_path__ + "static/media/embracedeath.0a7e14e6.png";